export default __webpack_public_path__ + "static/media/large-purple-check-2x.62713164.png";